var fontFamilyTable = {}; // 加载字体

export function loadFont(fontFamily) {
  if (fontFamilyTable[fontFamily]) {
    return;
  }

  fontFamilyTable[fontFamily] = true;

  try {
    if (document.fonts && document.fonts.load) {
      document.fonts.load("12px ".concat(fontFamily));
    }
  } catch (e) {
    console.error(e);
  }
}